import api from "./api";
const getSignature = () => localStorage.getItem("signature");

export const getAttendenceForAllEmloyees = async (
  date,
  slectedCompany = null,
  selectedDepartment = null,
  empStatus = "all",
) => {
  const signature = getSignature();
  if (slectedCompany == null) {
    return false;
  }
  const query = date ? `?date=${date}` : "";
  const data = await api.post(
    `attendanceService/getEmployeeAttendance${query}`,
    {
      signature,
      c_id: slectedCompany?.value,
      c_type: slectedCompany.type,
      department_id: selectedDepartment?.value,
      emp_status: empStatus,
    },
  );

  return data?.data || [];
};

export const downloadExtensivePayrollReport = async (
  payload,
  selectedCompany = null,
) => {
  const signature = getSignature();
  if (!selectedCompany) return false;

  return api.post(
    `attendanceService/downloadExtensivePayrollReport`,
    {
      signature,
      c_id: selectedCompany?.value,
      c_type: selectedCompany?.type,
      ...payload,
    },
    { responseType: "blob" },
  );
};

export const getAttendanceForExport = async (
  startDate,
  endDate,
  selectedCompany = null,
  selectedDepartment = null,
  empStatus = "all",
) => {
  const signature = getSignature();
  if (!selectedCompany) return false;

  const query =
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";

  const data = await api.post(
    `attendanceService/getEmployeeAttendanceRange${query}`,
    {
      signature,
      c_id: selectedCompany?.value,
      c_type: selectedCompany?.type,
      department_id: selectedDepartment?.value,
      emp_status: empStatus,
    },
  );

  return data?.data || [];
};

export const getAttendenceEmployeeDetails = async (
  userId,
  start,
  end,
  companyId,
  companyType,
) => {
  const queryParams = [];
  const signature = getSignature();

  if (userId) queryParams.push(`user_id=${userId}`);
  if (companyId) queryParams.push(`company_id=${companyId}`);
  if (companyType) queryParams.push(`company_type=${companyType}`);
  if (start)
    queryParams.push(
      `startDate=${encodeURIComponent(start.format("YYYY-MM-DD"))}`,
    );
  if (end)
    queryParams.push(`endDate=${encodeURIComponent(end.format("YYYY-MM-DD"))}`);

  const query = queryParams.length ? `?${queryParams.join("&")}` : "";

  const data = await api.post(`attendanceService/getEmloyeeDetails${query}`, {
    signature,
  });

  return data?.data || [];
};

export const getAllComapniesList = async () => {
  const signature = getSignature();
  const data = await api.post("userService/getAllCompanyList", { signature });
  return data;
};

export const getLeaveTypes = async (selectedCompany) => {
  const signature = getSignature();
  const data = await api.post(`attendanceService/get-leave-types`, {
    signature,
    company_id: selectedCompany?.value,
    company_type: selectedCompany?.type,
  });

  return data;
};

export const getLeaveBalance = async (leaveTypeId) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/get-leave-balance", {
    signature,
    leaveTypeId: leaveTypeId,
  });
  return data;
};

export const appplyLeave = async (leave) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/apply-leave", {
    signature,
    ...leave,
  });
  return data;
};

export const getUserLeaveSummary = async (params) => {
  const signature = getSignature();

  const data = await api.post("attendanceService/leave-summary", {
    signature,
    startDate: params?.startDate,
    endDate: params?.endDate,
  });

  return data;
};

export const getComapnyLeaveOverview = async (params = {}) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/get-company-leaveOverview", {
    signature,
    ...params,
  });
  return data;
};

export const updateLeaveStatus = async (
  leaveRequestId,
  status,
  rejectionReason,
) => {
  const signature = getSignature();

  const payload = {
    signature,
    leaveRequestId,
    status,
    ...(rejectionReason && { rejectionReason }), // only adds it if truthy
  };

  const data = await api.post("attendanceService/update-leave-status", payload);
  return data;
};

export const updateLeaveType = async (leaveRequestId, value) => {
  const signature = getSignature();
  const data = await api.post(
    `attendanceService/update-leave-type/${leaveRequestId}`,
    { signature, ...value },
  );

  return data;
};

export const createLeaveType = async (value) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/create-leave-type", {
    signature,
    ...value,
  });
  return data;
};

export const toggleLeaveTypeStatus = async (id, isActive) => {
  const signature = getSignature();
  const data = await api.post(
    `attendanceService/update-leave-type-status/${id}`,
    { signature, isActive },
  );
  return data;
};

export const deleteLeaveType = async (value) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/create-leave-type", {
    signature,
    ...value,
  });
  return data;
};
export const editAttendanceRecord = async (params) => {
  const {
    attendance_id,
    user_id,
    check_in,
    check_out,
    date,
    ip,
    location,
    updated_logs,
  } = params;
  const signature = getSignature();
  const data = await api.post("attendanceService/editAttendance", {
    signature,
    attendance_id,
    user_id,
    check_in,
    check_out,
    date,
    ip,
    location,
    updated_logs,
  });
  return data?.data || [];
};

export const getCompanySettings = async (c_id, c_type) => {
  const signature = getSignature();
  const data = await api.post("userService/getCompanySettings", {
    signature,
    c_id,
    c_type,
  });
  return data;
};

export const manualCheckIn = async (location, ip) => {
  try {
    const signature = getSignature();
    const data = await api.post("attendanceService/manual-checkin", {
      signature,
      location,
      ip,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDepartments = async (check_time) => {
  const signature = getSignature();
  const data = await api.post("userService/getDepartment", {
    signature,
    check_time,
  });
  return data;
};

export const saveCompanySettings = async (settings) => {
  const signature = getSignature();
  const data = await api.post("userService/save-company-settimgs", {
    signature,
    ...settings,
  });
  return data;
};

// services/attendanceService.js

let userImageCache = null;
let cacheTimestamp = null;
const CACHE_EXPIRY_MS = 60 * 60 * 1000; // 1 hour

export const getUserImages = async (userId) => {
  const now = Date.now();

  if (
    userImageCache &&
    cacheTimestamp &&
    now - cacheTimestamp < CACHE_EXPIRY_MS &&
    userImageCache[userId]
  ) {
    return userImageCache[userId];
  }

  const signature = getSignature();
  try {
    const response = await api.post("userService/getEmployeesListData", {
      signature,
    });
    const users = response?.data?.data?.data?.allUsers || [];

    userImageCache = {};
    users.forEach((user) => {
      if (user && user.key) {
        userImageCache[user.key] = user; // Cache full user object
      }
    });

    cacheTimestamp = now;

    return userImageCache[userId] || null;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const clearUserImageCache = () => {
  userImageCache = null;
  cacheTimestamp = null;
};

export const getAllEmployeesListDataByCompanyId = async (companyInfo) => {
  const signature = getSignature();

  const data = await api.post(
    "userService/getAllEmployeesListDataByCompanyId",
    {
      signature,
      companyId: companyInfo.company_id,
      companyType: companyInfo.company_type,
    },
  );

  return data?.data || [];
};

export const getIndividualEmployeeAttendanceReport = async (
  startDate,
  endDate,
  selectedCompany = null,
  selectedDepartment = null,
  selectedEmployee = null,
  empStatus = "all",
) => {
  const signature = getSignature();
  if (!selectedCompany || !selectedEmployee) return false;

  const query =
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";

  const data = await api.post(
    `attendanceService/getIndividualEmployeeAttendanceReport${query}`,
    {
      signature,
      c_id: selectedCompany?.value,
      c_type: selectedCompany?.type,
      department_id: selectedDepartment?.value,
      employee_id: selectedEmployee?.value,
      emp_status: empStatus,
    },
  );

  return data?.data || [];
};

export const getAllEmployeesDetailedAttendanceReport = async (
  startDate,
  endDate,
  selectedCompany = null,
  selectedDepartment = null,
  empStatus = "all",
) => {
  const signature = getSignature();
  if (!selectedCompany) return false;

  const query =
    startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : "";

  const data = await api.post(
    `attendanceService/getAllEmployeesDetailedAttendanceReport${query}`,
    {
      signature,
      c_id: selectedCompany?.value,
      c_type: selectedCompany?.type,
      department_id: selectedDepartment?.value,
      emp_status: empStatus,
    },
  );

  return data?.data || [];
};

// Update the function in attendanceService.js

export const exportLeavesReport = async (
  startDate,
  endDate,
  selectedCompany = null,
  selectedDepartment = null,
  selectedEmployee = null, // Changed to accept null
  status = "all",
  leaveTypeId = null,
  format = "excel",
) => {
  const signature = getSignature();
  if (!selectedCompany) return false;
  const data = await api.post(`attendanceService/export-leaves-report`, {
    signature,
    companyId: selectedCompany?.value,
    companyType: selectedCompany?.companyType,
    status: status || null,
    startDate: startDate || null,
    endDate: endDate || null,
    department_id: selectedDepartment?.value || null,
    employeeId: selectedEmployee?.value || null,
    leaveTypeId: leaveTypeId || null,
    format: format || "excel",
  });

  return data?.data || [];
};

export const adjustLeaveBalance = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/adjust-leave-balance", {
    signature,
    ...payload,
  });
  return data;
};

export const listBalanceAdjustments = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/list-balance-adjustments", {
    signature,
    ...payload,
  });
  return data;
};

export const getEmployeeBalanceDetail = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/get-employee-balance-detail", {
    signature,
    ...payload,
  });
  return data;
};

export const listEmployeeBalances = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/list-employee-balances", {
    signature,
    ...payload,
  });
  return data;
};

export const saveReportTemplate = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/saveReportTemplate", {
    signature,
    ...payload,
  });
  return data;
};

export const listReportTemplates = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/listReportTemplates", {
    signature,
    ...payload,
  });
  return data;
};

export const updateReportTemplate = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/updateReportTemplate", {
    signature,
    ...payload,
  });
  return data;
};

export const deleteReportTemplate = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/deleteReportTemplate", {
    signature,
    ...payload,
  });
  return data;
};

export const listPayrollReportDownloads = async (payload) => {
  const signature = getSignature();
  const data = await api.post("attendanceService/listPayrollReportDownloads", {
    signature,
    ...payload,
  });
  return data;
};

export const downloadHistoricalReport = async (payload) => {
  const signature = getSignature();
  return api.post(
    "attendanceService/downloadHistoricalReport",
    {
      signature,
      ...payload,
    },
    { responseType: "blob" },
  );
};
